export enum TimeRangeType {
    Predefined = 0,
    Custom = 1,
}
